import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

function useSearchParams() {
  const history = useHistory()
  const location = useLocation()

  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search)
  }, [location.search])

  const setSearchParams = useCallback(
    (searchParams: URLSearchParams | string) => {
      history.replace({ search: searchParams.toString() })
    },
    [history]
  )

  return [searchParams, setSearchParams] as const
}
export default useSearchParams
